import { HiVideoCamera } from 'react-icons/hi'

export default function VideoIcon() {
  return (
    <div className="absolute flex items-center justify-center right-0 bottom-0 m-2 h-8 w-8 bg-gray-900/80 rounded-full shadow-lg text-white/80">
      <HiVideoCamera className="h-5 w-5" />
    </div>
  )
}
